import { FC } from 'react';
import { useField } from 'react-final-form';
import { RENAME_WARNING } from '../constants';
import { isRenamed } from './utils';

type Props = {
  originalName: string;
};

export const RenameWarning: FC<Props> = ({ originalName }) => {
  const {
    input: { value },
  } = useField<string>('filter_name', { subscription: { value: true } });

  if (!isRenamed(originalName, value)) return null;
  return <span className="oath-utility errorRed">{RENAME_WARNING}</span>;
};
